import { useLayoutEffect, useRef } from "react";

/** TV: ate 3 cards visiveis na area; da 4a linha em diante existe overflow e esta rolagem liga automaticamente. */
const MAX_SEM_ROLAGEM_ATIVA = 3;
/** Desce do topo ao fim; no fim volta ao topo em ciclo. */
const VELOCIDADE_SCROLL_PX_S = 30;

function temScrollVertical(el: HTMLElement) {
  return el.scrollHeight - el.clientHeight > 0.5;
}

export function useFilaTvAutoScroll(
  itensQuantidade: number,
  listaFingerprint: string
) {
  const listaRef = useRef<HTMLDivElement>(null);

  const carouselAtivo = itensQuantidade > MAX_SEM_ROLAGEM_ATIVA;

  useLayoutEffect(() => {
    const el = listaRef.current;
    if (!el) return undefined;

    if (!carouselAtivo) {
      el.scrollTop = 0;
      return undefined;
    }

    const scrollBehaviorPrev = el.style.scrollBehavior;
    el.style.scrollBehavior = "auto";
    el.scrollTop = 0;

    let ultimoTs = performance.now();
    let rafId = 0;

    const pararLoop = () => {
      if (rafId !== 0) {
        window.cancelAnimationFrame(rafId);
        rafId = 0;
      }
    };

    const passo = (agoraTs: number) => {
      if (!temScrollVertical(el)) {
        pararLoop();
        return;
      }
      const max = el.scrollHeight - el.clientHeight;
      const dt = Math.min(agoraTs - ultimoTs, 56);
      ultimoTs = agoraTs;
      let proximo = el.scrollTop + VELOCIDADE_SCROLL_PX_S * (dt / 1000);
      if (proximo >= max - 0.5) {
        el.scrollTop = 0;
      } else {
        el.scrollTop = proximo;
      }
      rafId = window.requestAnimationFrame(passo);
    };

    const tentarIniciarLoop = () => {
      pararLoop();
      if (!temScrollVertical(el)) return;
      ultimoTs = performance.now();
      rafId = window.requestAnimationFrame(passo);
    };

    tentarIniciarLoop();

    let kickId2 = 0;
    const kickId1 = window.requestAnimationFrame(() => {
      tentarIniciarLoop();
      kickId2 = window.requestAnimationFrame(() => tentarIniciarLoop());
    });

    const ro = new ResizeObserver(() => tentarIniciarLoop());
    ro.observe(el);

    return () => {
      pararLoop();
      window.cancelAnimationFrame(kickId1);
      window.cancelAnimationFrame(kickId2);
      el.style.scrollBehavior = scrollBehaviorPrev;
      ro.disconnect();
    };
  }, [carouselAtivo, listaFingerprint, itensQuantidade]);

  return { listaRef, rolagemAutomatica: carouselAtivo };
}
